<template>
  <div class="member-guide">
    <div class="flex guide-head">
      <div class="guide-title">搭建会员系统</div>
      <div class="guide-content">
        <p>指导如何建立完善的会员体系，让会员和会员贡献价值有效增长。设置基本制度、营销、回访等方式，不断获取更多会员的行为习惯数据做分析，做好精准营销、主动营销。</p>
        <p>实现降低获客成本，提升营业额。</p>
      </div>
    </div>
    <div class="guide-set-title">会员系统功能设置</div>
    <div class="guide-set-content">
        <div class="track-list">
          <ul>
            <div v-for="(item,index) in logisticsList" :key="index" style="width: 100%;">
              <li class="flex">
                <div class="pop">{{item.title}}
                  <div class="arrow"></div>
                </div>
                <div style="flex:1;">
                  <i class="node-icon"></i>
                  <div v-for="(v,i) of item.content" :key="i" class="flex" style="justify-content: space-between;line-height: 40px;border-bottom:1px solid #f3f3f3;">
                    <div style="font-weight: bold">{{v.name}}</div>
                    <div>
                      <el-button v-for="(ele,k) of v.btnList" :key="k" :icon="ele.icon">{{ele.name}}</el-button>
                    </div>
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logisticsList: [
        {
          title:'会员制度',
          content:[
            {name:'设定等级',btnList:[],},
            {name:'等级权益',btnList:[{name:"优惠折扣",icon:'el-icon-circle-check'},{name:"会员价",icon:'el-icon-circle-check'},{name:"开卡红包",icon:'el-icon-circle-check'}],},
            {name:'积分产生',btnList:[{name:"积分规则",icon:'el-icon-warning-outline'},{name:"储值赠送积分",icon:'el-icon-circle-check'},],},
            {name:'积分消耗',btnList:[{name:"积分抵现",icon:'el-icon-circle-check'},{name:"积分商城",icon:'el-icon-goods'}],}
          ],
        },
        {
          title:'运营管理',
          content:[
            {name:'营销',btnList:[{name:"专属营销活动",icon:'el-icon-warning-outline'}],},
            {name:'促销',btnList:[{name:"会员优惠券",icon:'el-icon-circle-check'}],},
            {name:'提醒',btnList:[{name:"生日提醒",icon:'el-icon-warning-outline'}],},
          ],
        },
        {
          title:'数据分析',
          content:[
            {name:'查看相关报表',btnList:[],},
          ],
        },
      ],
    }
  },
  mounted() {
  },
  methods:{},
}
</script>
<style scoped>
.member-guide{
  padding:10px 50px;
  background-color: #f0f0f0;
  height:100%;
}
.guide-head{
  background-color: #ffffff;
  padding:10px 35px;
}
.flex{
  display: flex;
}
.guide-title{
  width:150px;
  font-size: 16px;
  font-weight: bold;
  align-items: center;
  line-height: 60px;
}
.guide-content{
  line-height: 30px;
  color: #666;
  width: 90%;
}
.guide-set-title{
  padding:10px 20px;
  background-color: #f5f5f5;
  margin-top: 10px;
}
.guide-set-content{
  background-color: #ffffff;
  padding:10px 20px;
}
ul {
  padding-left: 1.5rem
}
.member-title{
  width:100px;
  font-size: 16px;
}
.track-list{
  position:relative;
}
.track-list li{
  list-style:none;
  position:relative;
  padding:0px 0 30px 25px;
  border-left:1px solid #d9d9d9;
  width:95%;
}
.track-list li .node-icon{
  position: absolute;
  left: -6px;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  top:4px;
  background-color: #FDFAF2;
  border:1px solid #FFA518;
}
>>>.el-icon-circle-check{
  color:lightgreen;
}
>>>.el-icon-warning-outline{
  color:red;
}
>>>.el-icon-goods{
  color:orange;
}
/*气泡*/
.pop {
  position:relative;
  width:100px;
  height:35px;
  line-height: 33px;
  /*background:#fff;*/
  color:#fff;
  border-radius:5px; /* 圆角 */
  background-color: #4D4948;
  border:1px solid #4D4948;
  text-align: center;
  margin-right: 30px;
}

.pop .arrow {
  position:absolute;
  top:5px;
  left:-16px; /* 圆角的位置需要细心调试哦 */
  width:0;
  height:0;
  font-size:0;
  border:solid 8px;
  border-color:#fff #4D4948 #fff #fff;
}
</style>



// WEBPACK FOOTER //
// src/page/member/memberGuide.vue